import React from 'react';
import { useTheme } from '../../theme/ThemeContext';
import { useSelector } from 'react-redux';
import { selectIsDark } from '../../redux/features/platformSlice';

/**
 * Global Loading Overlay - Modernized
 */
export const GlobalLoading = () => {
  const theme = useTheme();
  const darkMode = useSelector(selectIsDark)
  const logoUrl = darkMode ? '/assets/img/icon-light.png' : '/assets/img/icon-dark.png';
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: theme.bg, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', zIndex: 9999,
      gap: '24px'
    }}>
      <style>{`
        @keyframes pulse-glow {
          0%, 100% { filter: drop-shadow(0 0 16px ${theme.primary}55); transform: scale(1); }
          50% { filter: drop-shadow(0 0 30px ${theme.primary}95); transform: scale(1.04); }
        }
        @keyframes rotate-slow {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={{
        position: 'relative', width: 80, height: 80,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <div style={{
          position: 'absolute', width: '100%', height: '100%',
          border: `4px solid ${theme.primary}20`,
          borderTop: `4px solid ${theme.primary}`,
          borderRadius: '50%',
          animation: 'rotate-slow 1.5s linear infinite'
        }} />
        <div style={{
          width: 54, height: 54,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          animation: 'pulse-glow 2s ease-in-out infinite'
        }}>
          <img
            src={logoUrl}
            alt="Core Prime LTD"
            style={{ width: 48, height: 48, objectFit: 'contain' }}
          />
        </div>
      </div>
      <div style={{
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: 20, fontWeight: 800, color: theme.text,
          letterSpacing: '0.15em', textTransform: 'uppercase'
        }}>
          Core Prime LTD
        </div>
        <div style={{ fontSize: 12, color: theme.textM, marginTop: 6, letterSpacing: '0.02em' }}>
          Initialising secure session...
        </div>
      </div>
    </div>
  );
};

/**
 * Local Component Loader - Clean and minimal
 */
export const ComponentLoader = ({ height = '100%', message }) => {
  const theme = useTheme();
  return (
    <div style={{
      width: '100%', height, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: 'transparent',
      gap: '12px'
    }}>
      <style>{`
        @keyframes dot-bounce {
          0%, 80%, 100% { transform: scale(0); opacity: 0; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      <div style={{ display: 'flex', gap: '8px' }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: 8, height: 8, borderRadius: '50%',
            background: theme.primary,
            animation: `dot-bounce 1.4s infinite ease-in-out both`,
            animationDelay: `${i * 0.16}s`
          }} />
        ))}
      </div>
      {message && <div style={{ fontSize: 11, color: theme.textS, fontWeight: 500, letterSpacing: '0.02em' }}>{message}</div>}
    </div>
  );
};

/**
 * Small Inline Spinner - Minimal
 */
export const InlineSpinner = ({ size = 14, color }) => {
  const theme = useTheme();
  return (
    <div style={{
      display: 'inline-block', width: size, height: size,
      border: `2px solid ${theme.border}`, borderTop: `2px solid ${color || theme.primary}`,
      borderRadius: '50%', animation: 'rotate-slow 0.8s linear infinite'
    }} />
  );
};
